import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=e5ed38ba&scoped=true&"
import script from "./CampaignSummary.vue?vue&type=script&lang=js&"
export * from "./CampaignSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ed38ba",
  null
  
)

export default component.exports